<template>
  <section class="profile">
    <div class="container-fluid p33">
      <div class="row">
        <div class="col-md-3 p0">
          <Profilecard></Profilecard>
        </div>
        <div class="col-md-9 pl20">
          <b-tabs defaultActiveKey="profile" content-class="mt-3">
            <b-tab
              v-for="(aSection, index) in sections"
              :key="index"
              :title="aSection.title"
            >
              <component
                :is="aSection.component"
                v-bind="Object.assign({}, propsData)"
                :ref="aSection.componentName"
              >
              </component>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Profilecard from "./profileCard/index";
import Profileinfo from "./profileInfo/index";
import Notifications from "./notifications/index";
import Connections from "./connections/index";
import Accounts from "./accounts/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      sections: [
        {
          title: "My Info",
          id: "info",
          component: Profileinfo,
          componentName: "Profileinfo"
        },
        {
          title: "Connections",
          id: "connection",
          component: Connections,
          componentName: "Connections"
        },
        {
          title: "Notifications",
          id: "notifications",
          component: Notifications,
          componentName: "Notifications"
        },
        {
          title: "Accounts",
          id: "accounts",
          component: Accounts,
          componentName: "Accounts"
        }
      ]
    };
  },
  created() {
    this.$nprogress.start();
    this.$store
      .dispatch("user/getProfile")
      .then(() => {
        this.$nprogress.done();
      })
      .catch(error => {
        this.$nprogress.done();
        this.$store.dispatch("user/showNotification", {
          title: error.code,
          description: error.message,
          variant: "danger"
        });
      });
  },
  components: {
    Profilecard,
    Profileinfo,
    Notifications,
    Accounts,
    Connections
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    propsData() {
      return {
        profile: this.profile
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  margin-top: 32px;
}

@media (min-width: 767px) {
  .p33 {
    // padding: 0 33px !important;
    width: 92% !important;
  }
}
@media (min-width: 767px) {
  .p33 {
    // padding: 0 33px !important;
    width: 92% !important;
  }
  .pl20 {
    padding: 0 20px;
    padding-left: 30px;
  }
  .p0 {
    padding: 0 !important;
  }
}
</style>
